export * from './abstract.entity';